export default function VideoForm({
  isForEdit = false,
  formValues,
  setFormValues,
  handleSubmit,
}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  return (
    <form
      className="mt-8 space-y-6 mx-auto max-w-md px-5 lg:px-0"
      action="#"
      method="POST"
      onSubmit={handleSubmit}
    >
      <h1 className="text-xl text-center font-bold">
        {isForEdit ? "Edit video" : "Add video"}
      </h1>
      <div className="form-group">
        <label htmlFor="title">Title</label>
        <input
          id="title"
          name="title"
          type="text"
          onChange={handleChange}
          value={formValues.title}
          required
          className="login-input rounded-t-md"
          placeholder="Video title"
        />
      </div>
      <div className="form-group">
        <label htmlFor="description">Video Description</label>
        <textarea
          name="description"
          id="description"
          rows="5"
          onChange={handleChange}
          value={formValues.description}
          required
          className="login-input rounded-t-md"
          placeholder="Video description"
        ></textarea>
      </div>
      <div className="form-group">
        <label htmlFor="url">Video Url</label>
        <input
          id="url"
          name="url"
          type="text"
          onChange={handleChange}
          value={formValues.url}
          required
          className="login-input rounded-t-md"
          placeholder="Video url"
        />
      </div>
      <div className="form-group">
        <label htmlFor="views">Video views(in K format)</label>
        <input
          id="views"
          name="views"
          type="number"
          onChange={handleChange}
          value={formValues.views}
          step="0.1"
          min="0"
          required
          className="login-input rounded-t-md"
          placeholder="views format: 1.2k/5.1k"
        />
      </div>
      <div className="form-group">
        <label htmlFor="duration">Video duration</label>
        <input
          id="duration"
          name="duration"
          type="text"
          onChange={handleChange}
          value={formValues.duration}
          pattern="[0-9]+:[0-5][0-9]"
          required
          className="login-input rounded-t-md"
          placeholder="duration format: 00:00"
        />
      </div>

      <button
        type="submit"
        className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
      >
        Submit
      </button>
    </form>
  );
}
